import request from "@/utils/request";
import qs from "qs";

/**
 * 查询订单
 * @param params
 * @returns {*}
 */
export function getOrderList(params) {
  return request({
    url: "/shoporder/getList",
    method: "get",
    params,
    paramsSerializer: values => qs.stringify(values, { arrayFormat: "repeat" })
  });
}

export function getOrderConfig() {
  return request({
    url: "/shoporder/config",
    method: "get"
  });
}

export function saveOrderConfig(data) {
  return request({
    url: "/shoporder/config",
    method: "put",
    data
  });
}

/**
 * 查询修改收货地址申请
 */
export function getAddressModifyList(params) {
  return request({
    url: "/shoporder/getAddressModifyList",
    method: "get",
    params
  });
}

/**
 * 审核修改收货地址申请
 */
export function auditAddressModify(params) {
  return request({
    url: "/shoporder/auditAddressModify",
    method: "post",
    params
  });
}

/**
 * 后台直接修改订单收货地址并自动生成已通过记录
 */
export function directModifyAddress(data) {
  return request({
    url: "/shoporder/directModifyAddress",
    method: "post",
    data,
    headers: { "Content-Type": "application/json" }
  });
}

/**
 * 订单列表【导出】
 * @param params
 * @returns {*}
 */
export function exportOrderList(params) {
  return request({
    url: "/shoporder/exportList",
    method: "get",
    responseType: "blob", // 重要：设置responseType为'blob'以处理二进制数据
    params,
    paramsSerializer: values => qs.stringify(values, { arrayFormat: "repeat" })
  });
}

/**
 * 查询订单商品列表
 * @param params
 * @returns {*}
 */
export function getGoodsList(params) {
  return request({
    url: "/shoporder/getGoodsList",
    method: "get",
    params
  });
}

/**
 * 发货回执
 * @param params
 * @returns {*}
 */
export function deliveryFeedback(params) {
  return request.post("/shoporder/deliveryFeedback", qs.stringify(params));
}

export function getDeliveryPackages(params) {
  return request({
    url: "/shoporder/getDeliveryPackages",
    method: "get",
    params
  });
}

export function saveDeliveryPackages(data) {
  return request({
    url: "/shoporder/saveDeliveryPackages",
    method: "post",
    data,
    headers: { "Content-Type": "application/json" }
  });
}

export function modifyExpressNo(data) {
  return request({
    url: "/shoporder/modifyExpressNo/1015",
    method: "post",
    data,
    headers: { "Content-Type": "application/json" }
  });
}

export function getPendingDeliveryOrders(params) {
  return request({
    url: "/shoporder/pendingDelivery",
    method: "get",
    params
  });
}

export function batchDelivery(data) {
  return request({
    url: "/shoporder/batchDelivery",
    method: "post",
    data,
    headers: { "Content-Type": "application/json" }
  });
}

export function importOfflineOrders(file) {
  const data = new FormData();
  data.append("file", file);
  return request({
    url: "/shoporder/importOfflineOrders",
    method: "post",
    data,
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120000
  });
}

/**
 * 查询售后订单列表
 * @param params
 * @returns {*}
 */
export function getOrderAfterList(params) {
  return request({
    url: "/orderafter/getList",
    method: "get",
    params
  });
}

/**
 * 按当前筛选条件导出售后订单列表
 */
export function exportOrderAfterList(params) {
  return request({
    url: "/orderafter/exportList",
    method: "get",
    responseType: "blob",
    timeout: 45000,
    params
  });
}
/**
 * 查询售后订单详情
 * @param params
 * @returns {*}
 */
export function getOrderAfterDetail(params) {
  return request({
    url: "/orderafter/getDetail",
    method: "get",
    params
  });
}

/**
 * 确认收货
 * @param params
 * @returns {*}
 */
export function confirmOrderAfterReceipt(params) {
  return request.post("/orderafter/confirmReceipt", qs.stringify(params));
}
/**
 * 售后订单反馈
 * @param params
 * @returns {*}
 */
export function feedbackOrderAfter(params) {
  return request.post("/orderafter/feedback", qs.stringify(params));
}
/**
 * 发货回执
 * @param params
 * @returns {*}
 */
export function deliveryOrderAfterFeedback(params) {
  return request.post("/orderafter/deliveryFeedback", qs.stringify(params));
}

/**
 * 查询订单详情
 * @param params
 * @returns {*}
 */
export function getOrderDetail(params) {
  return request({
    url: "/shoporder/getDetail",
    method: "get",
    params
  });
}

export function getSupplyList(params) {
  return request({
    url: "/schl/getSchlOrderInfoList",
    method: "get",
    params
  });
}

export function getSynchronize(params) {
  return request({
    url: "/schl/synchronizeExpressLogistics",
    method: "get",
    params
  });
}

export function getSupplyOrderInfo(params) {
  return request({
    url: "/schl/getOrderInfo",
    method: "get",
    params
  });
}

// 订单审核
export function auditOrder(params) {
  return request.post("/shoporder/audit", qs.stringify(params));
}
